import React from 'react';
import { Paper, Skeleton, Box } from '@mui/material';
import { themeColors } from '../../utils/theme';

/**
 * LoadingMetricCard Component
 * 
 * A skeleton loader component that matches the visual structure and styling of LifetimeMetricCard.
 * Used to display loading state while metric data is being fetched.
 * 
 * @returns React component displaying a loading metric card skeleton
 */
export const LoadingMetricCard: React.FC = () => {
  return (
    <Paper
      elevation={2}
      sx={{
        p: 2,
        borderRadius: '8px',
        height: '100%',
        borderLeft: `4px solid ${themeColors.accent || '#41C8C4'}`,
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: themeColors.paper,
      }}
      role="status"
      aria-label="Loading metric card"
    >
      {/* Label Skeleton */}
      <Skeleton 
        variant="text" 
        width="60%" 
        height={20}
        sx={{ 
          mb: 1,
          bgcolor: `${themeColors.accent || '#41C8C4'}40`,
        }}
      />
      
      {/* Value Skeleton - larger to match metric display */}
      <Skeleton 
        variant="text" 
        width="80%" 
        height={40}
        sx={{ 
          mb: 1,
          bgcolor: `${themeColors.accent || '#41C8C4'}40`,
        }}
      />
      
      {/* Description/Unit Skeleton */}
      <Skeleton 
        variant="text" 
        width="40%" 
        height={16}
        sx={{ 
          bgcolor: `${themeColors.accent || '#41C8C4'}40`,
        }}
      />
    </Paper>
  );
};

export default LoadingMetricCard;
